var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"salesCell"},[_vm._v("\n\t"+_vm._s(_vm._f("formatPrice2")(_vm._f("formatPrice")(_vm._f("formatEmpty")(_vm.row.sales30Days))))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }